<template>
  <el-form
    ref="calculationForm"
    :model="model"
    label-width="15em"
    label-position="left"
  >
    <slot></slot>
    <BillingYm v-model="billingYm" :required="true" :mode="billingYmMode" />
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
// import ImportFile from '@/components/molecules/form/upload/ImportFile.vue'
// import Encoding from 'encoding-japanese'

export default {
  components: {
    BillingYm
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    label: String,
    action: String,
    params: Object,
    billingYmMode: String
  },
  data () {
    return {
    }
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    }
  },
  methods: {
    clear () {
      this.$refs.calculationForm.resetFields()
      this.billingYm = this.getDefaultBillingYm()
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.calculationForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.upload {
  display: flex;
  ::v-deep .el-upload {
    order: 2;
  }
  ::v-deep .el-upload-list {
    order: 1;
    width: 100%;
    margin-right: 1em;
    .el-upload-list__item {
      margin-top: 0;
    }
  }
}
</style>
